var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermalStationWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97872 18.2558C7.43617 19.0698 7.07447 20.2093 7.07447 21.186C7.07447 21.6744 7.43617 22 7.97872 22H17.0213C17.5638 22 17.9255 21.6744 17.9255 21.186C17.9255 20.2093 17.5638 19.3954 17.0213 18.5814C18.144 18.0199 19.1808 17.3035 20.0127 16.3788C20.5226 15.8119 20.0631 15 19.3006 15H5.79232C5.00941 15 4.56026 15.8459 5.11735 16.396C5.92617 17.1946 6.91373 17.8298 7.97872 18.2558Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.576 11.8392H19.924C20.462 11.8392 21 12.5595 21 12.9196C21 13.4598 20.462 14 19.924 14H5.07595C4.53797 14 4 13.4598 4 12.9196C4 12.5595 4.53797 11.8392 5.07595 12.0193H11.424V6.68168C11.424 5.24116 10.3481 4.16077 8.9135 4.16077C7.4789 4.16077 6.40295 5.24116 6.40295 6.68168V8.16721C6.40295 8.88747 5.86498 9.2476 5.327 9.2476C4.78903 9.2476 4.25105 8.7074 4.25105 8.16721V6.68168C4.25105 4.16077 6.40295 2 8.9135 2C10.3481 2 11.6034 2.72026 12.5 3.62058C13.2173 2.72026 14.4726 2 15.9072 2C18.597 2 20.5696 4.16077 20.7489 6.68168V8.16721C20.7489 8.7074 20.211 9.2476 19.673 9.2476C19.135 9.2476 18.597 8.7074 18.597 8.16721V6.68168C18.597 5.24116 17.5211 4.16077 16.0865 4.16077C15.3692 4.16077 14.6519 4.34084 14.2932 4.88103C13.9346 5.42123 13.576 5.96142 13.576 6.68168V11.8392Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermalStationWhite);
export default __webpack_public_path__ + "static/media/thermal-station-white.d7b47c3facaeb77fdaafedd26217c575.svg";
export { ForwardRef as ReactComponent };